/*
 * @Author: zhuyating 
 * @Date: 2023-06-08 
 */
import { init } from '@didi/webx-js';
/**
 * @name: webx九章init行为
 * @param {*}
 * @return {*}
 */

const isDev = process.env.NODE_ENV === 'development';

export const initWebx = async () => {
  return new Promise(resolve => {
    init({
      initOption: {
        need_page_config: false,
        env: isDev ? 'offline' : 'online'
      }
    })
      .then(res => {
        if (res?.xpsid) {
          resolve(res);
        }
        resolve();
      })
      .catch(err => {
        resolve(err);
      });
  });
};
